<div class="state-dialog">
  <div class="state-dialog-header">
    <div class="header-copy">
      <span class="eyebrow">{{ sourceArea }} · {{ contextLabel }}</span>
      <h2>Cambiar estado del file</h2>
      <p>Revisa el cambio antes de confirmarlo. Esta acción quedará registrada con tu usuario.</p>
    </div>
    <button mat-icon-button type="button" aria-label="Cerrar" (click)="cancelar()" [disabled]="isLoading">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <section class="file-summary">
    <span class="summary-icon">
      <mat-icon>description</mat-icon>
    </span>
    <div>
      <span class="summary-label">File seleccionado</span>
      <strong>{{ fileLabel }}</strong>
    </div>
  </section>

  <div class="transition-card" *ngIf="hasStateChangeAction; else unavailableState">
    <div class="state-box current">
      <span class="state-label">Estado actual</span>
      <strong>{{ currentState }}</strong>
    </div>

    <span class="transition-icon-shell">
      <mat-icon class="transition-icon">arrow_forward</mat-icon>
    </span>

    <div class="state-box next">
      <span class="state-label">Estado objetivo</span>
      <strong>{{ targetState }}</strong>

      <div class="target-picker" *ngIf="hasMultipleTargets">
        <button
          type="button"
          class="target-chip"
          *ngFor="let state of nextStates"
          [class.target-chip-active]="selectedTarget === state"
          [disabled]="isLoading"
          (click)="selectTarget(state)"
        >
          {{ state }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #unavailableState>
    <div class="unavailable-state">
      <mat-icon>info</mat-icon>
      <div>
        <h3>Cambio no disponible</h3>
        <p>Este estado no tiene un siguiente estado disponible desde Operations.</p>
      </div>
    </div>
  </ng-template>

  <section class="motive-field" *ngIf="hasStateChangeAction && requiresMotive">
    <label class="motive-label" for="state-motive">Motivo</label>
    <textarea
      id="state-motive"
      class="motive-input"
      rows="3"
      [(ngModel)]="motive"
      [disabled]="isLoading"
      placeholder="Ingrese el motivo del cambio"
    ></textarea>
  </section>

  <div class="state-note" *ngIf="hasStateChangeAction && !requiresMotive">
    <mat-icon>verified</mat-icon>
    <div>
      <strong>Acción manual de Operations</strong>
      <span>El estado se guardará y verás el cambio reflejado en la tabla al finalizar.</span>
    </div>
  </div>

  <section class="automatic-reference" *ngIf="hasAutomaticReference">
    <div class="automatic-reference-header">
      <mat-icon>schedule</mat-icon>
      <div>
        <h3>Cambios automáticos del sistema</h3>
        <p>Estos estados no se cambian manualmente desde Operations.</p>
      </div>
    </div>
    <div class="automatic-state-list">
      <div class="automatic-state-item" *ngFor="let transition of automaticTransitions">
        <div class="automatic-state-flow">
          <strong>{{ transition.fromState }}</strong>
          <mat-icon>arrow_forward</mat-icon>
          <strong>{{ transition.toState }}</strong>
        </div>
        <p>{{ transition.description }}</p>
      </div>
    </div>
  </section>

  <section class="sales-reference" *ngIf="hasSalesReference">
    <div class="sales-reference-header">
      <mat-icon>info</mat-icon>
      <div>
        <h3>Referencia Sales para registro</h3>
        <p>Estos cambios pertenecen al flujo de Sales y no se ejecutan desde Operations.</p>
      </div>
    </div>
    <div class="sales-state-list">
      <span class="sales-state-chip" *ngFor="let state of salesNextStates">{{ state }}</span>
    </div>
  </section>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button type="button" class="cancel-button" [disabled]="isLoading" (click)="cancelar()">
      Cancelar
    </button>
    <button mat-raised-button class="accept-button" [disabled]="!canConfirm" (click)="save()">
      <span *ngIf="!isLoading">Confirmar cambio</span>
      <span *ngIf="isLoading" class="loading-text">
        <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
        Procesando...
      </span>
    </button>
  </mat-dialog-actions>
</div>
